const config = {
  firebase: {
    apiKey: import.meta.env.VITE_APIKEY,
    authDomain: import.meta.env.VITE_AUTHDOMAIN,
    databaseURL: import.meta.env.VITE_DATABASEURL,
    projectId: import.meta.env.VITE_PROJECTID,
    storageBucket: import.meta.env.VITE_STORAGEBUCKET,
    messagingSenderId: import.meta.env.VITE_MESSAGINGSENDERID,
    appId: import.meta.env.VITE_APPID,
    measurementId: import.meta.env.VITE_MEASUREMENTID,
  },
  google: {
    API_KEY: import.meta.env.VITE_GOOGLE_API_KEY,
    CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
    SECRET: import.meta.env.VITE_GOOGLE_SECRET_KEY,
  },
  facebook: {
    APP_ID: import.meta.env.VITE_FACEBOOK_APP_ID,
  },
  stripe: {
    publicKey: import.meta.env.VITE_STRIPE_PUBLIC_KEY || '',
  },
}

export default config
